import script from "./TheCrowdfunding.vue?vue&type=script&setup=true&lang=js"
export * from "./TheCrowdfunding.vue?vue&type=script&setup=true&lang=js"

import "./TheCrowdfunding.vue?vue&type=style&index=0&id=6003c2c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6003c2c5"]])

export default __exports__